
/*eslint-disable no-console */
export default class Console {
    static log(message) {
        console.log(message);
    }

    static warn(message) {
        console.warn(message);
    }
}
/*eslint-enable no-console */